<template>
  <div
    class="grid"
    :class="[
      { 'grid-cols-1': props.cols1 },
      { 'grid-cols-2': props.cols2 },
      { 'grid-cols-3': props.cols3 },
      { 'grid-cols-4': props.cols4 },
      { 'grid-cols-5': props.cols5 },
      { 'grid-cols-6': props.cols6 },
      { 'grid-cols-7': props.cols7 },
      { 'grid-cols-8': props.cols8 },
      { 'grid-cols-9': props.cols9 },
      { 'grid-cols-10': props.cols10 },
      { 'gap-1': props.gap1 },
      { 'gap-2': props.gap2 },
      { 'gap-3': props.gap3 },
      { 'gap-4': props.gap4 },
      { 'gap-5': props.gap5 },
      { 'gap-6': props.gap6 },
      { 'gap-7': props.gap7 },
      { 'gap-8': props.gap8 },
      { 'gap-9': props.gap9 },
      { 'gap-10': props.gap10 },
      { 'items-center justify-center': center },
      { 'items-start': itemsStart },
      { 'items-center': itemsCenter },
      { 'items-end': itemsEnd },
      { 'justify-start': justifyStart },
      { 'justify-center': justifyCenter },
      { 'justify-end': justifyEnd },
      { 'justify-between': justifyBetween },
    ]">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  gap1: Boolean,
  gap2: Boolean,
  gap3: Boolean,
  gap4: Boolean,
  gap5: Boolean,
  gap6: Boolean,
  gap7: Boolean,
  gap8: Boolean,
  gap9: Boolean,
  gap10: Boolean,
  cols1: Boolean,
  cols2: Boolean,
  cols3: Boolean,
  cols4: Boolean,
  cols5: Boolean,
  cols6: Boolean,
  cols7: Boolean,
  cols8: Boolean,
  cols9: Boolean,
  cols10: Boolean,
  center: Boolean,
  itemsStart: Boolean,
  itemsCenter: Boolean,
  itemsEnd: Boolean,
  justifyStart: Boolean,
  justifyCenter: Boolean,
  justifyEnd: Boolean,
  justifyBetween: Boolean,
})
</script>
